/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const SUPERVISOR_CAN_ABILITY = [
  //Route Access

  ["read", "MyProfile"],
  ["read", "ZeroPaymentReport"],
  ["read", "PartialPaymentReport"],
  ["read", "PresentationList"],
  ["read", "FullPaymentReport"],
  ["read", "SalesReport"],
  ["read", "CommitteMemberReport"],
  ["read", "PaymentReport"],
  ["read", "DeliveredReport"],
  ["read", "DeletedBox"],
  ["read", "InviteMasqueraderPurchase"],
  ["read", "CommDisList"],
  ["read", "MasqueraderList"],
  ["read", "CreateMasqBox"],
  ["read", "CommitteList"],
  ["read", "AboutMe"],
  ["read", "OrgProfile"],
  ["read", "SwitchSection"],
  ["read", "InviteCommitteMember"],
  // ["read", "CommitteReport"],
  ["read", "ViewMasqBoxDetails"],
  ["read", "ChangeCostumeOptions"],
  ["read", "MasqViewBox"],
  ["read", "MasqBoxList"],
  ["read", "ViewBoxDetails"],
  ["read", "CashierList"],
  ["read", "InviteesList"],
  ["read", "PrintLabels"],
];

export const SUPERVISOR_CANNOT_ABILITY = [
  //Route Access Denial
  //  ["read", "Button"],
  ["read", "Costume"],
  ["read", "CostumeOpenReg"],
  ["read", "InviteList"],
  ["read", "Purchase"],
  ["read", "OpenRegistrationCostumePage"],
  ["read", "DashboardOverview"],
  ["read", "DashboardIssuerAnalysis"],
  ["read", "UserList"],
  ["read", "Masquerader"],
  ["read", "DiscountReport"],
  ["read", "BlackListUsers"],
  ["read", "Committe"],
  ["read", "Presentation"],
  ["read", "InventoryView"],
  ["read", "Invite"],
  ["read", "DeletedViewBox"],
  ["read", "PresentationInventory"],
  ["read", "SectionOptionInventory"],
  ["read", "InventoryControl"],
  ["read", "MasqueraderReport"],
  ["read", "PurchasedCostume"],
  ["read", "SectionBasePriceSummary"],
  ["read", "DiscountInvite"],

  ["read", "OpenRegister"],
  ["read", "PaymentTransaction"],
  ["read", "ManageOpenRegistration"],
  ["read", "FHPolicy"],
  ["read", "ProfileUpdateStepper"],
  ["read", "CostumeInventoryReport"],
  ["read", "SectionOptInvReport"],
  ["read", "ScheduleTable"],
  ["read", "ShelfList"],
  ["read", "ScheduleList"],
  ["read", "ShelfDetail"],
  ["read", "BoxDetail"],
  ["read", "DiscountCodeTemplate"],
  ["read", "OTPTemplate"],
  ["read", "MasqInvitationWithDiscountTemplate"],
  ["read", "MasqInvitationTemplate"],
  ["read", "CommitteeInvitationTemplate"],
  ["read", "MasqDownPaymentTemplate"],
  ["read", "DeletedBoxTemplate"],
  ["read", "AdminInvitationTemplate"],
  ["read", "DiscountInviteTemplate"],
  ["read", "CashierInviteTemplate"],
  ["read", "CostumePurchaseInviteTemplate"],
  ["read", "InvoiceTemplate"],
  ["read", "TransferBoxNewUserTemplate"],
  ["read", "TransferBoxOldUserTemplate"],
  ["read", "CommonEmailVerificationTemplate"],
  ["read", "PreBookInviteTemplate"],
  ["read", "PreBookDownPaymentEmailTemplate"],
  ["read", "PartialRemainderEmailTemplate"],
  ["read", "UnPaidRemainderEmailTemplate"],
];
